import { filter, combineLatest, skip, take, switchMap } from 'rxjs/operators';
import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { DisposableSafelly } from '@toro/common/shared/components/disposable-safelly/disposable-safelly.component';
import { HomeStatus } from '@toro/common/shared/enum/home-status.enum';
import { SuitabilityProfilesEnum } from '@toro/common/shared/enum/suitability/suitability-profiles.enum';
import { UserAccountLevel, UserAccountLevelName } from '@toro/common/shared/enum/user/account-level';
import { ImportedBy } from '@toro/common/shared/enum/user/importedby';
import { SuitabilityProfileModel } from '@toro/common/shared/models/suitability/suitabilityProfile.model';
import { User } from '@toro/common/shared/models/User';
import { LiveSetting } from '@toro/common/shared/resources/live-setting';
import { AgreementsAction } from '@toro/common/shared/state-management/agreements/agreements.action';
import { AdvisorAction } from '@toro/common/shared/state-management/advisor/advisor.action';
import { SuitabilityAction } from '@toro/common/shared/state-management/suitability/suitability.action';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';
import { UserProfileState } from '@toro/common/shared/state-management/userprofile/userprofile.reducer';
import { UsersState } from '@toro/common/shared/state-management/users/users.reducer';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Observable, Subscription } from 'rxjs';
import { fadeInOutAnimation } from '@hub-workspace/apps/logged-home/src/app/shared/animations/fade-in-out-animation';
import { infoHomeLoggedPage } from '../../../../shared/utils';
import { AdvisorEntity } from '@toro/common/shared/entities/advisor.entity';
import { ILoggedHomeAppState } from '@hub-workspace/apps/logged-home/src/app/shared/interfaces/logged-home-app-state.interface';
import { AdvisorTypeEnum } from '@toro/common/shared/models/Advisor';
import { ThemePalette } from '@angular/material/core';
import { STVMDigitalAction } from '@hub-workspace/apps/logged-home/src/app/state-management/stvm-digital/stvm-digital.action';
import { StorageService } from '@toro/common/shared/services/storage.service';
import { SantanderSuitabilityService } from '@toro/common/shared/services/santander-suitability/santander-suitability-service';
import { UserReRegistationService } from '@toro/common/shared/services/re-registration/user-re-registration.service';
import { IReRegistrationMessage } from '@toro/common/shared/interfaces/re-registration/re-resgistration.interface';
import { ModalComponent } from '@toro/common/shared/components/modal/modal.component';
import { environment } from '@hub-workspace/apps/logged-home/src/environments/environment';
import { combineLatest as combineLatestFunc } from 'rxjs';
import { PortabilityService } from '@hub-workspace/apps/hub/src/app/partials/custody-portability/services/portability/portability.service';
import { IPortabilityRequest, RequestStatus } from '@hub-workspace/apps/hub/src/app/partials/custody-portability/my-requests/custody-portability-requests.models';
import { ModalAccessFullWalletComponent } from '../../../../shared/modules/customer-wallet/components/modal-full-wallet/modal-access-full-wallet.component';
import { DialogsService } from '@toro/common/shared/services/dialogs.service';
import {
  WALLET_FULL_ACCESS_ALERT_LINK_LABEL,
  WALLET_FULL_ACCESS_ALERT_TEXT_DEFAULT,
  WALLET_FULL_ACCESS_ALERT_TEXT_SANTANDER,
} from '@hub-workspace/apps/logged-home/src/app/shared/modules/customer-wallet/components/wallet-full-access-alert/wallet-full-access-alert.constants';
import { OneViewExperienceVariant } from '@hub-workspace/apps/logged-home/src/app/shared/modules/customer-wallet/services/oneview-experience-variant/oneview-experience-variant.util';
import { OneViewExperienceVariantService } from '@hub-workspace/apps/logged-home/src/app/shared/modules/customer-wallet/services/oneview-experience-variant/oneview-experience-variant.service';
import { tap } from 'rxjs/operators';


const MINIMUM_AGREEMENT_REQUIRED = 4;
const MINIMUM_DAYS_ONBOARD_PI = 30;

@AutoUnsubscribe()
@Component({
  selector: 'home-logged-user-opened-account',
  templateUrl: './home-logged-user-opened-account.component.html',
  styleUrls: ['./home-logged-user-opened-account.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [],
  animations: [
    fadeInOutAnimation
  ],
})
export class HomeLoggedUserOpenedAccountComponent extends DisposableSafelly implements OnInit {
  @ViewChild("modalUserRegister", { static: true })
  public modalUserRegister: ModalComponent;

  color: ThemePalette = 'warn';

  @Input() public homeRole: HomeStatus;
  @Input() public pendingFinanceInformation: boolean = true;
  @Input() public negativeOnD0: boolean = false;
  @Input() public getAprovalByLastCBLCNumber: boolean = false;
  @Input() public totalNetEquity: number = 0;

  @Output() public isShowValue = new EventEmitter<boolean>();
  @Output() public isOpenModalIntegrationPi = new EventEmitter<boolean>();

  public homeStatus = HomeStatus;
  public showRecomendations: boolean = false;
  public activeLiveChat: boolean = true;
  public showLearn: boolean = false;
  public userIdentifier: string = null;
  public infoHomeLoggedPage = infoHomeLoggedPage;
  public theme: string = LiveSetting.backgroundStyle.lighter;
  public isMobile: boolean = false;
  public tooltips: { [prop: string]: string } = {};
  public advisor: AdvisorEntity;
  public hotjarClass: any = null;
  public UserAccountLevelName = UserAccountLevelName;
  public badgeColor = '#6131B3'
  public userAccountLevelLastName = ''
  public hasCustomerWallet: boolean = false;
  public isNewBrand: boolean = environment.isNewBrand
  public hasPendingPortability: boolean = false;
  public hasPendingPortabilityAction: boolean = false;

  public oneViewExperienceVariant: OneViewExperienceVariant | null = null;
  public oneViewExperienceVariant$: Observable<OneViewExperienceVariant>;

  /* Observables */
  public authentication$: Observable<UsersState>;
  public user$: Observable<UserProfileState>;
  public disposableSubscriptions: Subscription[] = [];

  // TODO: INIT - Remover aproximadamente 30 após todo tombamento clientes Pi US: 44990 --- fernando.souza
  public user: User;
  public agreementsAccepted: any[] = [];
  public channelLive: string = 'livePi';
  public suitability: SuitabilityProfileModel = new SuitabilityProfileModel();

  public isOpenLive = false;
  public isPiOnboard: boolean = false;
  public isIntegrationToroPiPending: boolean = false;
  // TODO: END - Remover aproximadamente 30 após todo tombamento clientes Pi US: 44990 --- fernando.souza
  public cookieExclusiveStatus: string;
  public cookieTraderStatus: string;
  public isExclusive: boolean;
  public isTrader: boolean;
  public fixedIncomeBalance: number;
  public fundsBalance: number;
  public stockBalance: number;
  public modalUserReRegistration: IReRegistrationMessage;

  constructor(
    private store: Store<ILoggedHomeAppState>,
    private userReRegistationService: UserReRegistationService,
    private portabilityService: PortabilityService,
    private dialogsService: DialogsService,
    private oneViewExperienceVariantService: OneViewExperienceVariantService,
    private santanderSuitabilityService: SantanderSuitabilityService,
  ) {
    super();

    this.store.dispatch({ type: AgreementsAction.getAgreementStatus });
    this.store.dispatch({ type: SuitabilityAction.getProfile });
    this.store.dispatch({ type: STVMDigitalAction.getPortabilities });

    this.authentication$ = this.store.select((state) => state.authentication);
    this.user$ = this.store.select((state) => state.userProfile);

    // Subscribe que trata as varáveis de cenário
    this.disposableSubscriptions.push(
      this.user$.subscribe((userData) => {
        this.userIdentifier = userData.user.cpfcnpj;
      }),
    );

    this.getScreenWidth();

    this.cookieTraderStatus = StorageService.getCookie('hubUserTraderStatus');
    this.cookieExclusiveStatus = StorageService.getCookie('hubUserExclusiveStatus');
    this.isExclusive = this.cookieExclusiveStatus == 'true';
    this.isTrader = this.cookieTraderStatus == 'true';
  }

  public sendTrackingEvents(event: string, breakdowns: any) {
    this.store.dispatch({
      type: TrackingActions.trackEvents,
      payload: { type: event, events: breakdowns },
    });
  }

  public trackWalletCardClick(cardTitle: string) {
    this.sendTrackingEvents('Element Clicked', {
      'Product Area Origin': 'Home Varejo',
      'Time Responsável': 'Sky',
      'Element': `Card ${cardTitle}`,
      'Group': 'Sua carteira',
    });
  }

  public ngOnInit() {
    this.trackOperationalLimitPageLoad();

    // TODO: Remover aproximadamente 30 após todo tombamento clientes Pi US: 44990 --- fernando.souza
    this.store
      .select(({ userProfile }) => userProfile.user).pipe(
        combineLatest(
          this.store.select(({ suitability }) => suitability),
          this.store.select(({ agreements }) => agreements),
          this.store.select(({ finance }) => finance),
        ),
        filter(([{ profile }, suitability, { acceptedAgreements }]) => !!profile && !!suitability.profile && !!acceptedAgreements),)
      .subscribe(([user, { profile }, { acceptedAgreements }, { finance, consolidatePosition: consolidated }]) => {

        this.user = user;
        this.agreementsAccepted = acceptedAgreements;
        this.suitability.profile = profile.profile;
        this.validateWelcomePi();
        this.fixedIncomeBalance = consolidated.totalFixedIncome;
        this.fundsBalance = consolidated.totalFunds;
        this.stockBalance = consolidated.totalExchange;
      });

    this.disposableSubscriptions.push(
      this.store
        .select((state) => state.advisor.customerAdvisor)
        .pipe(skip(1))
        .subscribe((data) => this.advisor = data),

      this.store
        .select((state) => state.customerWallet.wallet)
        // .pipe(skip(1))
        .subscribe((wallet) => this.hasCustomerWallet = !!wallet),
    );

    this.store.dispatch({ type: AdvisorAction.getAdvisor });

    this.getUserRegistrationStore();

    this.disposableSubscriptions.push(
      this.store.select((state) => state.stvmPortabilities)
        .pipe(
          filter(stvmState => !!stvmState && !!stvmState.portabilities)
        )
        .subscribe((stvmState) => {
          this.checkPortabilityStatus(stvmState.portabilities);
        })
    );

    this.checkPendingPortabilities();

    this.oneViewExperienceVariant$ = this.oneViewExperienceVariantService.variant$.pipe(
      take(1),
      tap((variant) => this.oneViewExperienceVariant = variant),
    );
  }

  public ngOnChanges(): void {
    this.verifyHotjarClass();
    this.changeBadgeColor();
    this.checkUserAccountLevelLastName();
  }

  public openModalAccessFullWallet() {
    this.dialogsService.showComponnent(ModalAccessFullWalletComponent);

    const isNewExperience = this.oneViewExperienceVariant === 'new';
    const alertText = isNewExperience
      ? WALLET_FULL_ACCESS_ALERT_TEXT_SANTANDER
      : WALLET_FULL_ACCESS_ALERT_TEXT_DEFAULT;

    this.sendTrackingEvents("Element Clicked", {
      'Product Area Origin': 'Home',
      'Time Responsável': "Mezzo",
      'Element': 'Link Saiba mais',
      'Group': 'Alert Carteira',
      'Step': 'Não se aplica',
      'Scenario': 'Varejo',
      'Text': `${alertText} ${WALLET_FULL_ACCESS_ALERT_LINK_LABEL}`
    });
  }

  public checkUserAccountLevelLastName() {
    this.userAccountLevelLastName = this.userAccountLevel.split(" ")[1]
  }

  public changeBadgeColor() {
    const possibleBadgeColors = {
      [UserAccountLevelName.EXCLUSIVE]: '#1F063A',
      [UserAccountLevelName.DIGITAL]: '#6131B3',
    }

    this.badgeColor = possibleBadgeColors[this.userAccountLevel];
  }


  public verifyHotjarClass() {
    const isMobileFormat = this.isMobile ? 'mobile' : 'desktop';

    const possiblesHotjarClasses = {
      [UserAccountLevelName.EXCLUSIVE]: `hotjar-cliente-exclusivo-${isMobileFormat}`,
      [UserAccountLevelName.DIGITAL]: `hotjar-cliente-digital-${isMobileFormat}`,
    }

    const domElementsClasses = {
      container: possiblesHotjarClasses[this.userAccountLevel],
    }

    this.hotjarClass = domElementsClasses;
  }

  public userIsExclusiveAccount() {
    return (
      this.userAccountLevel &&
      this.userAccountLevel === UserAccountLevelName.EXCLUSIVE
    );
  }

  /**
   * Método que é chamado ao clicar em "Mais detalhes"
   *
   * @param action action
   */
  public sendTracking(event: string, action: string) {
    this.sendToTracking(event, { userLogin: this.userIdentifier, element: action });
  }

  public linkAttendenceLevels() {
    this.sendToTracking('User Clicked', { userLogin: this.userIdentifier, origin: 'Home', element: 'Link níveis de atendimento' });
  }

  public scrollInterationClickButtom() {
    const body = $('html, body');
    const scrollTopElement = $('#doubts-section')
      .offset().top;

    body.animate(
      { scrollTop: scrollTopElement },
      700,
    );
  }

  public sendToTracking(typeAction: string, eventsTracking: Record<string, any>) {
    const payloadUser = { type: typeAction, events: eventsTracking };
    this.store.dispatch({ type: TrackingActions.trackEvents, payload: payloadUser });
  }

  /**
   * Método que scrolla a página para a dobra selecionada
     * @param id anchor
     */
  public goTo(id: string) {
    const element = $(id);
    $('html, body')
      .animate({
        scrollTop: element.offset().top,
      }, 1200);
  }

  /**
   * Obtem a largura da tela
   */
  public getScreenWidth(): boolean {
    this.isMobile = window.innerWidth <= 768;
    return this.isMobile;
  }

  // TODO: Remover aproximadamente 30 após todo tombamento clientes Pi US: 44990 --- fernando.souza
  /**
   * Valida usuarios tombados Pi para Toro para preenchimentos de docs
   */
  public validateWelcomePi() {

    const isImportedBy = this.user.importedBy === ImportedBy.Pi || this.user.importedBy === ImportedBy.UpdatedPi;

    if (!isImportedBy) return;

    const isAgreement = this.agreementsAccepted && this.agreementsAccepted.length >= MINIMUM_AGREEMENT_REQUIRED;
    const isSuitability = this.suitability.profile !== SuitabilityProfilesEnum.NoProfile;

    this.isIntegrationToroPiPending = !(isAgreement && isSuitability);

    if (!isAgreement) return;

    this.validatePiOnboard();
  }

  // TODO: Remover aproximadamente 30 após todo tombamento clientes Pi US: 44990 --- fernando.souza
  /**
   * Valida usuarios tombados Pi com direito a cursos até o limit definido MINIMUM_DAYS_ONBOARD_PI
   * 1000 = millesecondes | 60 = minutes and seconds | 24 = hours day
   */
  public validatePiOnboard() {

    const dateCurrent = new Date().getTime();
    const dateAgreement = new Date(this.agreementsAccepted[0].updatedAt).getTime();

    const diffDays = Math.floor((dateCurrent - dateAgreement) / (1000 * 60 * 60 * 24));

    this.isPiOnboard = !this.isIntegrationToroPiPending && diffDays <= MINIMUM_DAYS_ONBOARD_PI;
  }

  // TODO: Remover aproximadamente 30 após todo tombamento clientes Pi US: 44990 --- fernando.souza
  public openModalWelcomePi() {
    this.isOpenModalIntegrationPi.emit(true);
  }

  // TODO: Remover aproximadamente 30 após todo tombamento clientes Pi US: 44990 --- fernando.souza
  /**
   * Obtem altera status open e close live
   */
  public toogleLive() {
    const idContentLive = this.getScreenWidth() ? 'live_mobile' : 'live_desktop';
    const elementHtml = document.getElementById(idContentLive);

    this.isOpenLive = !this.isOpenLive;

    if (this.isOpenLive) elementHtml.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // TODO: Remover aproximadamente 30 após todo tombamento clientes Pi US: 44990 --- fernando.souza
  /**
   * Obtem o estado do toogle assistir live
   * @param {boolean} event
   */
  public getToogleLive(event: boolean) {
    this.isOpenLive = event;
  }

  public changeShow(event: boolean) {
    this.isShowValue.emit(event);
  }

  public get hasExclusiveNetEquity() {
    return this.totalNetEquity >= UserAccountLevel.EXCLUSIVE;
  }

  /**
  * Determina o level de conta do usuário para atedimento posteriores
  *
  * @param user
  */
  public get userAccountLevel() {
    if (this.advisor && this.advisor.type == AdvisorTypeEnum.EXCLUSIVE || this.hasExclusiveNetEquity) {
      return 'Conta Exclusiva';
    }

    return 'Conta Digital';

  }

  public get hideAmount() {
    return window.localStorage.getItem('showTraderInfoValues') === 'false';
  }

  /**
   * Busca os registros status do usuário
   */
  private getUserRegistrationStore() {
    this.store
      .select(({ userProfile }) => userProfile)
      //   .pipe(take(2))
      .subscribe((up) => {
        if (!up.user || !+up.user.registrationStatus) {
          return;
        }
        this.verifyUserReRegister(+up.user.registrationStatus);
      });
  }

  /**
   * verifica se usuário esta expirado
   * Expired = 15
   * PreExpirado = 18
   */
  private verifyUserReRegister(registrationStatus: number) {
    const userExpired = this.userReRegistationService.validateUserExpired(
      registrationStatus
    );
    if (userExpired) {
      this.modalUserReRegistration = userExpired;
      this.modalUserRegister.show();
      return;
    }

    const userPreExpired = this.userReRegistationService.validateUserPreExpired(
      registrationStatus
    );
    if (userPreExpired) {
      this.modalUserReRegistration = userPreExpired;
      this.modalUserRegister.show();
      return;
    }
  }

  private trackOperationalLimitPageLoad() {
    this.disposableSubscriptions.push(
      combineLatestFunc([
        this.store.select((state) => state.userProfile),
        this.store.select((state: any) => state.operationalLimit)
      ]).pipe(
        filter(([up, op]) =>
          !!up.user &&
          !!op &&
          !op.pending &&
          this.santanderSuitabilityService.getClientSegment() !== 'Trader'
        ),
        take(1)
      ).subscribe(([, op]) => {
        const accepted = op?.value?.isAccepted === true;

        let santanderLimit = 'ativo';
        if (!accepted) {
          santanderLimit = 'inativo';
        }

        const productArea = this.isExclusive ? 'Home Exclusiva' : 'Home Varejo';

        this.sendTrackingEvents("Page Loaded", {
          'Product Area Origin': productArea,
          'Status': "Conta ativa",
          'Step': 'Não se aplica',
          'Time Responsável': "Sky",
          'Specific Properties': {
            'Santander Operational Limit': santanderLimit,
            'user_type': this.santanderSuitabilityService.getClientSegment()
          }
        });
      })
    );
  }

  // Método auxiliar para validar a regra de negócio
  private checkPortabilityStatus(portabilities: any[]) {
    // Cenário: Portabilidade de Saída com Status de Ação Pendente
    // Nota: Verifique o ENUM exato do seu backend. Exemplo comum: 'WAITING_USER_APPROVAL' ou 'PENDING_ACTION'
    this.hasPendingPortability = portabilities.some(request =>
      request.type === 'OUT' &&
      request.status === 'WAITING_USER_APPROVAL' // Valide este status com seu Swagger/Backend
    );
  }

  public checkPendingPortabilities() {
    this.disposableSubscriptions.push(
      this.store
        .select((state) => state.authentication.currentUser.cblc)
        .pipe(
          filter((cblc) => !!cblc),
          take(1),
          switchMap((cblc: string) => this.portabilityService.getPortabilityRequests(cblc))
        )
        .subscribe((requests: IPortabilityRequest[]) => {
          const now = new Date().getTime();
          const fourHoursInMs = 4 * 60 * 60 * 1000;

          this.hasPendingPortabilityAction =
            requests.some(request => {
              const requestTime = new Date(request.requestDate).getTime();
              const diff = now - requestTime;
              return request.status === RequestStatus.ACTION_PENDING && diff < fourHoursInMs;
            });
        })
    );
  }
}


